"use strict";

exports.__esModule = true;
exports.default = void 0;
var _DragDrop = _interopRequireDefault(require("./DragDrop.js"));
exports.default = _DragDrop.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }